import { Transaction } from './types';

export const exportTransactionsToCSV = (transactions: Transaction[], filename = 'transactions.csv') => {
  if (!transactions.length) return;

  const headers = [
    'Date',
    'Type',
    'Category',
    'Note',
    'Amount (USD)',
    'Naira Amount',
    'Relationship',
  ];

  const csvContent = [
    headers.join(','),
    ...transactions.map((t) => {
      const row = [
        t.date,
        t.type,
        `"${(t.category || '').replace(/"/g, '""')}"`,
        `"${(t.note || '').replace(/"/g, '""')}"`,
        t.amount.toFixed(2),
        t.nairaAmount ? t.nairaAmount.toFixed(2) : '',
        `"${(t.relationship || '').replace(/"/g, '""')}"`,
      ];
      return row.join(',');
    }),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
